import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import ActivePage from "../../../partials/active-page";
import NewAdminForm from "./NewAdminForm";
import AdminList from "./AdminList";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { GET_ADMINS, REVOKE, NEW_SUPER_ADMIN, RE_ASSIGN } from "../../../queries/super-admin-query";
import LoadingSpinner from "../../../partials/loading";
import AlertMessage from "../../../partials/alertMessage";
import auth from "../../../providers/Auth.Provider";
import { Redirect } from "react-router-dom";

const SuperAdmin = ({ match, location }) => {
    // local state
    const [newAdmin, setAdmin] = useState(false);
    // props
    const title = "Super Administrator";

    const pages = [
        {
            title: "Application Management",
            path: "/home/app-management",
        },
        { title, path: match.path },
    ];

    // prepare queries
    const { loading: gLoading, data: gData, error: gError } = useQuery(GET_ADMINS);

    // New Super admin mutation
    const [NewSuperAdminFunc, { loading: nLoading, data: nData }] = useMutation(NEW_SUPER_ADMIN, {
        update(caches, { data: { GrantSuperAdminRights } }) {
            // read query
            const { GetSuperAdmins } = caches.readQuery({
                query: GET_ADMINS,
            });
            // Update local state
            GetSuperAdmins.docs.unshift(GrantSuperAdminRights.doc);
            // Update cache back
            caches.writeQuery({
                query: GET_ADMINS,
                data: { GetSuperAdmins },
            });
        },
    });

    const [RevokeRights, { loading: rLoading, data: rData, error: rError }] = useMutation(REVOKE);

    // Cancel Revoke
    const [CancelRevoke, { data: cData, error: cError }] = useMutation(RE_ASSIGN);

    if (gError && auth.authProvider.IsAuthenticationError(gError.message)) {
        auth.authProvider.LogOut();
        return (
            <Redirect
                to={{
                    pathname: "/login",
                    search: `?redirect=${location.pathname}`,
                }}
            />
        );
    }

    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>
            <ActivePage pages={pages} title={title} />

            <div className="row justify-content-center">
                <div className="col-md-12 text-right m-b-10">
                    <button
                        type="button"
                        onClick={() => {
                            setAdmin(!newAdmin);
                            document.body.scrollTop = 0;
                            document.documentElement.scrollTop = 0;
                        }}
                        className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success"
                    >
                        <i className="material-icons">security</i> New Super Admin
                    </button>
                </div>
                <div className={`${newAdmin ? "col-md-8" : "col-md-10"} col-sm-12 fade-in`}>
                    <div>
                        <LoadingSpinner loading={gLoading || rLoading} />
                        <AlertMessage message={(gError && gError.message) || (rError && rError.message) || (cError && cError.message)} failed={true} />
                        <AlertMessage message={(rData && rData.RevokeSuperAdminRights.message) || (cData && cData.CancelSuperAdminRightsRevoke.message)} failed={false} />
                    </div>
                    {!gLoading && (
                        <AdminList
                            items={gData && gData.GetSuperAdmins.docs}
                            onRevoke={async (item) => {
                                await RevokeRights({ variables: { id: item.id } });
                            }}
                            onCancelRevoke={async (item) => {
                                await CancelRevoke({ variables: { id: item.id } });
                            }}
                        />
                    )}
                </div>
                {newAdmin && (
                    <div className="col-md-4 col-sm-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>New Super Admin Form</header>
                            </div>
                            <div className="card-body m-b-20">
                                <div>
                                    <LoadingSpinner loading={nLoading} />
                                    <AlertMessage message={nData && nData.GrantSuperAdminRights.message} failed={false} />
                                </div>
                                <NewAdminForm
                                    onSubmit={async (id) => {
                                        await NewSuperAdminFunc({
                                            variables: { staff: id },
                                        });
                                    }}
                                    onCancel={() => setAdmin(!newAdmin)}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default SuperAdmin;
